export interface LensUsage {
    readonly lensId: string;
    readonly lensName: string;
}

export const LENS_USAGE_LIMIT = 10;
